module.exports = __webpack_public_path__ + "img/bgtop.ed43ac53.jpg";